import React, { memo } from 'react';
import PropTypes from 'prop-types';

const BedsThick = ({ color, ...props }) => (
  <svg viewBox="0 0 24 24" {...props}>
    <g
      stroke={color}
      strokeWidth={props.strokeWidth || 1.25}
      fillOpacity="0"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    >
      <path d="M19.473 4.5h2.027l2 12h-23l2-12h2.278" />
      <path
        strokeLinecap="round"
        d="M23.5 21c0 .829-.672 1.5-1.5 1.5h-20c-.829 0-1.5-.671-1.5-1.5v-4.5h23v4.5zM2.167 8.5h19.666"
      />
      <path
        strokeLinecap="round"
        d="M10.542 6.5h-6.042l.417-3h5.687zM13.709 6.5h6.041l-.416-3h-5.688zM2.5 4.5v-2.5c0-.828.671-1.5 1.5-1.5h16c.828 0 1.5.673 1.5 1.5v2.5M3.5 22.5v1M20.5 22.5v1M10.604 4.614h3.042"
      />
    </g>
  </svg>
);

BedsThick.defaultProps = {
  width: 40,
  height: 40,
  color: 'currentColor',
};

BedsThick.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default memo(BedsThick);
